var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21949 10.6028C6.29282 10.4588 6.40455 10.338 6.5423 10.2537C6.68006 10.1694 6.83847 10.1248 6.99999 10.125H21C21.1613 10.1251 21.3195 10.1699 21.457 10.2543C21.5944 10.3387 21.7059 10.4594 21.7791 10.6032C21.8522 10.747 21.8842 10.9082 21.8715 11.069C21.8588 11.2298 21.8018 11.384 21.707 11.5145L14.707 21.1395C14.6258 21.2509 14.5194 21.3415 14.3966 21.4039C14.2737 21.4664 14.1378 21.499 14 21.499C13.8622 21.499 13.7263 21.4664 13.6034 21.4039C13.4806 21.3415 13.3742 21.2509 13.293 21.1395L6.29299 11.5145C6.19816 11.3843 6.14111 11.2304 6.12815 11.0698C6.11518 10.9093 6.14678 10.7483 6.21949 10.6045",
    fill: "#091540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownIcon);
export default __webpack_public_path__ + "static/media/triangle-down-icon.7a1fd1c9db9e94cf6034b038208accd5.svg";
export { ForwardRef as ReactComponent };